<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal="false"
      width="550px"
      title="发票详情"
      class="invoice-dialog"
    >
      <div class="rpg-dialog-item rpg-text-center">
        <el-button size="mini" type="primary" @click="addInvoice">新增开票</el-button>
      </div>
      <div class="invoice-box">
        <div
          v-for="(item, index) in finance.发票"
          :key="index"
          :class="[item.isDeleted ? 'drop-finance' : '', 'invoice']"
        >
          <span v-if="item.isDeleted && couldDelete" class="delete-invoice-btn" @click="removeInvoice(item, index)"
            >删除</span
          >
          <div class="invoice-row">
            <span class="half">开票批次：{{ getBatch(item.开票批次) }}</span>
            <span class="half">开票比例：{{ item.开票比例 }}%</span>
          </div>
          <div class="invoice-row">
            <span class="half">候选人：{{ finance.候选人 }}</span>
            <span class="half">开票金额：{{ item.开票金额 }}</span>
          </div>
          <div class="invoice-row">
            <span>客户公司：{{ item.客户公司 }}</span>
          </div>
          <div class="invoice-row">
            <span>开票主体：{{ item.开票主体 }}</span>
          </div>
          <div class="invoice-row">
            <!-- <span>开票信息：{{item.开票信息}}</span> -->
            <span class="invoice-label">开票信息：</span>
            <div>
              <p
                v-for="file in files"
                :key="file._id"
                class="md5"
                style="cursor:pointer;color:#409EFF"
                @click="preview(file)"
              >
                {{ file.originalname }}
              </p>
            </div>
          </div>
          <div v-if="item.开票时间" class="invoice-row">
            <span>开票时间：{{ dateFormat(item.开票时间) }}</span>
          </div>
          <div v-if="item.回款时间" class="invoice-row">
            <span>回款时间：{{ dateFormat(item.回款时间) }}</span>
          </div>
          <div class="invoice-status">
            <el-button size="mini" :type="getInvoiceStatusColor(item)" @click="updateStatus(item)">{{
              item.状态
            }}</el-button>
          </div>
        </div>
      </div>
      <!-- <div class="rpg-dialog-item rpg-text-center">
        <el-button size="mini" type="primary" @click="handleConfirm">确认offer</el-button>
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
      </div> -->
      <!-- <div class="rpg-dialog-item rpg-text-center">
        <span class="rpg-tip-red">发起offer会通知相应的顾问，最终双方确认</span>
      </div> -->
    </el-dialog>
    <AddInvoice ref="AddInvoice" @addInvoice="confirmAddInvoice"></AddInvoice>
    <!-- 选择时间 -->
    <el-dialog :title="dateDialogTitle" :visible.sync="dateDialogVisible" :close-on-click-modal="false" :modal="false">
      <el-date-picker v-model="datepicker" type="date" placeholder="选择日期"> </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="dateDialogVisible = false">取 消</div>
        <div class="radish-btn radish-btn-primary radish-btn-small" @click="onConfirmDate">确 定</div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import AddInvoice from './AddInvoice'

const dateFormat = require('dateformat')

export default {
  components: { AddInvoice },
  data() {
    return {
      dialogVisible: false,
      rid: '',
      pid: '',
      radish: {},
      project: {},
      form: {
        合同比例类型: '%',
      },
      finance: {},
      dateDialogVisible: false,
      dateDialogTitle: '',
      datepicker: '',
      files: [],
      couldDelete: false,
    }
  },
  mounted() {
    this.couldDelete = app.user.account === 'NateYu'
  },
  methods: {
    removeInvoice(item, index) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          this.finance.发票.splice(index, 1)
          const result = await window.app
            .service('company')
            .updateFinance({ id: this.finance._id, data: { 发票: this.finance.发票 } })
          if (result.status === 'success') this.$message('删除成功!')
          else this.$message('保存失败，请稍后重试')
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' })
        })
    },
    getBatch(val) {
      if (val === '0') return '一次付款'
      else if (val === '1') return '第一期'
      else if (val === '2') return '第二期'
    },
    async preview(file) {
      const ref = app.root.$refs.cvPreview
      if (!ref) return
      await ref.getFile(file)
      ref.show()
    },
    dateFormat(time) {
      return dateFormat(time, 'yyyy-mm-dd')
    },
    getInvoiceStatusColor(invoice) {
      return invoice.isDeleted || ['未开票', '未回款'].includes(invoice.状态) ? 'info' : 'primary'
    },
    async getCompany() {
      const res = await app.service('company').getCompany(this.finance.客户公司)
      if (res.status === 200) {
        this.company = res.result
        this.files = res.result.附件.filter(v => v.type === '开票信息')
      }
    },
    addInvoice() {
      this.$refs.AddInvoice.open(this.finance)
    },
    updateStatus(item) {
      if (item.isDeleted) return
      if (!['未开票', '未回款'].includes(item.状态)) return
      this.activeInvoice = item
      this.datepicker = Date.now()
      this.dateDialogVisible = true
      this.dateDialogTitle = item.状态 === '未开票' ? '开票时间' : '回款时间'
    },
    async onConfirmDate() {
      this.$set(
        this.activeInvoice,
        this.activeInvoice.状态 === '未开票' ? '开票时间' : '回款时间',
        new Date(this.datepicker).getTime(),
      )
      this.activeInvoice.状态 = this.activeInvoice.状态 === '未开票' ? '未回款' : '已回款'
      this.dateDialogVisible = false
      const result = await window.app
        .service('company')
        .updateFinance({ id: this.finance._id, data: { 发票: this.finance.发票, invoiceBadge: false } })
      const res = await app
        .service('radish')
        .modifyStatus({ rid: this.finance.rid, pid: this.finance.pid, status: { detail: '已开票' } })
      if (result.status === 'success') this.$message('修改成功')
      else this.$message('保存失败，请稍后重试')
    },
    async confirmAddInvoice(invoice) {
      this.dialogVisible = true
      const arr = this.finance.发票 || []
      arr.forEach(v => (v.isDeleted = true))
      if (invoice.开票批次 === '一次付款') {
        arr.push({
          开票批次: '0',
          开票比例: 100,
          候选人: invoice.候选人,
          开票金额: parseFloat(invoice.总金额),
          客户公司: invoice.客户公司,
          开票主体: invoice.开票主体,
          状态: '未开票',
        })
      } else {
        arr.push({
          开票批次: '1',
          开票比例: parseFloat(invoice.第一期),
          候选人: invoice.候选人,
          开票金额: parseFloat(invoice.总金额) * parseFloat(invoice.第一期) * 0.01,
          客户公司: invoice.客户公司,
          开票主体: invoice.开票主体,
          状态: '未开票',
        })
        arr.push({
          开票批次: '2',
          开票比例: parseFloat(invoice.第二期),
          候选人: invoice.候选人,
          开票金额: parseFloat(invoice.总金额) * parseFloat(invoice.第二期) * 0.01,
          客户公司: invoice.客户公司,
          开票主体: invoice.开票主体,
          状态: '未开票',
        })
      }
      // Object.assign(this.finance, { 发票: arr })
      await app
        .service('radish')
        .modifyStatus({ rid: this.finance.rid, pid: this.finance.pid, status: { detail: '开票中' } })
      const result = await window.app.service('company').updateFinance({ id: this.finance._id, data: { 发票: arr } })
      if (result.status === 'success') {
        this.$message('保存成功')
        // Object.assign(this.finance, { 发票: arr })
        this.$set(this.finance, '发票', arr)
      } else {
        this.$message('保存失败，请稍后重试')
      }
    },
    async open(finance) {
      this.finance = finance
      const invoice = (finance.发票 || []).filter(v => !v.isDeleted)
      if (invoice.length === 0) this.addInvoice()
      else this.dialogVisible = true
      this.getCompany()
    },
    async handleConfirm() {
      if (!this.form.职位) return this.$message('请填写职位')
      if (!this.form.固定年薪) return this.$message('请填写固定年薪')
      if (!this.form.到岗日期) return this.$message('请填写到岗日期')
      if (!this.form.合同比例) return this.$message('请填写合同比例')
      if (!this.form.试用期) return this.$message('请填写试用期')
      if (!this.form.佣金额) return this.$message('请填写佣金额')
      if (!this.form.业绩分成) return this.$message('请填写业绩分成')
      this.form.isMaybe = false
      const res = await app
        .service('radish')
        .updateOffer({ rid: this.finance.rid, pid: this.finance.pid, data: this.form, type: 'confirm' })
      if (res.status == 'success') {
        this.onConfirm()
        this.$message.success('操作成功')
        this.dialogVisible = false
      } else {
        this.$message.error(res.msg)
      }
    },
    confirmFencheng(fen) {
      this.form.业绩分成 = fen
    },
  },
}
</script>

<style scoped>
.invoice {
  border: 1px solid #eee;
  padding: 10px 20px;
  border-radius: 8px;
  width: 500px;
  margin-bottom: 10px;
  position: relative;
}
.delete-invoice-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #f56c6c;
  cursor: pointer;
}
.drop-finance {
  background-color: #eee;
}
.invoice .invoice-row {
  margin-bottom: 5px;
  display: flex;
}
.invoice .invoice-row .half {
  width: 50%;
}
.invoice-label {
  flex: none;
  word-break: keep-all;
  width: 80px;
}
.invoice-status {
  display: flex;
  justify-content: flex-end;
}
</style>
